export enum OrderStatusEnum {
  NEW = 'new',
  FIRST_BID = 'first-bid',
  SECOND_PLUS_BID = 'second-plus-bid',
  SECOND_BID = 'second-bid',
  THIRD_PLUS_BID = 'third-plus-bid',
  PAUSED = 'paused',
  PAUSED_LOCK = 'paused-lock',
  WAIT_FOR_CONFIRM = 'wait-for-confirm',
  WAIT_FOR_TRADE = 'wait-for-trade',
  WAIT_FOR_TRADE_CONFIRM = 'wait-for-trade-confirm',
  ORDER_CRATED = 'order-crated',
  WAIT_FOR_BUYER_ACCEPT = 'wait-for-buyer-accept',
  CANCELED_BY_SELLER_BEFORE_TRADE = 'canceled-by-seller-before-trade',
  CANCELED_BY_BUYER = 'canceled-by-buyer',
  CANCELED_BY_SELLER = 'canceled-by-seller',
  CANCELED_BY_TIMER = 'canceled-by-timer',
  CANCELED_BY_FASTOFFER = 'canceled-by-fastoffer',
  AUCTION_FINISHED = 'auction-finished',
  COMPLETED = 'completed',
  DELETED = 'deleted',
  DELETED_LOCK = 'deleted-lock',
  HOLD = 'hold',
  REFUND_BY_SELLER = 'refund-by-seller',
}

export const BIDDING_STATUSES: string[] = [
  OrderStatusEnum.NEW,
  OrderStatusEnum.FIRST_BID,
  OrderStatusEnum.SECOND_PLUS_BID,
  OrderStatusEnum.SECOND_BID,
  OrderStatusEnum.THIRD_PLUS_BID,
];

export const WAITING_STATUSES: string[] = [
  OrderStatusEnum.WAIT_FOR_CONFIRM,
  OrderStatusEnum.WAIT_FOR_TRADE,
  OrderStatusEnum.WAIT_FOR_TRADE_CONFIRM,
  OrderStatusEnum.WAIT_FOR_BUYER_ACCEPT,
];

export const FINISH_STATUSES: string[] = [
  OrderStatusEnum.CANCELED_BY_SELLER_BEFORE_TRADE,
  OrderStatusEnum.CANCELED_BY_BUYER,
  OrderStatusEnum.CANCELED_BY_SELLER,
  OrderStatusEnum.CANCELED_BY_TIMER,
  OrderStatusEnum.CANCELED_BY_FASTOFFER,
  OrderStatusEnum.AUCTION_FINISHED,
  OrderStatusEnum.COMPLETED,
  OrderStatusEnum.DELETED,
  OrderStatusEnum.DELETED_LOCK,
  OrderStatusEnum.HOLD,
  OrderStatusEnum.REFUND_BY_SELLER,
];
